import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { useVModel } from '@vueuse/core';
import { ref, watch } from 'vue';
import dayjs from 'dayjs';
import { addEnterprise } from '@/api/tenant';
import { DOC_MENU, shortcuts } from '@/constant';
import { formRule } from '../config';
import AccountSearch from './AccountSearch';
import { ElMessage } from 'element-plus';
import { getSmsUserConfigPage } from '@/api/sms';
import { getFeishuTenantList } from '@/api/feishu';
import { getAllAccountData } from '@/api/account';
import { regionData } from 'element-china-area-data';
export default {
  __name: 'SubTenant',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    parentId: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    model: {
      type: Object,
      default: () => {}
    },
    headquartersFromOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'data', 'clearModel'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const dialogTenantVisible = useVModel(props);
    const handleChangeCity = val => {
      const province = regionData.find(item => item.value === val[0]);
      const city = province.children.find(item => item.value === val[1]);
      const area = city.children.find(item => item.value === val[2]);
      form.value.province = province.label;
      form.value.city = city.label;
      form.value.area = area.label;
    };
    const form = ref({
      selectedOptions: null,
      picture: '',
      picUrl: '',
      username: '',
      fsTenantId: '',
      password: '',
      name: '',
      expireDate: Date.now(),
      // clinicId: '',
      accountId: '',
      description: '',
      menu: [],
      mobile: '',
      telephone: '',
      address: '',
      email: '',
      isParent: 0,
      // 是否是总部
      cluePoolShow: 0,
      // 线索池是否显示,
      parentId: '',
      smsId: '',
      enableStatus: 1,
      province: '',
      // 省
      city: '',
      // 市
      area: '',
      // 区
      contact: '',
      isSwitchMall: 0,
      // 是否开通商城功能
      membershipSystem: 0,
      qrCodePath: '' // his扫描二维码跳转到预约小程序界面路径
    });
    watch(() => props.model, val => {
      if (val) {
        let selectedOptions = [];
        try {
          var _province$children, _city$children;
          const province = regionData.find(item => item.label === val.province);
          const city = province === null || province === void 0 || (_province$children = province.children) === null || _province$children === void 0 ? void 0 : _province$children.find(item => item.label === val.city);
          const area = city === null || city === void 0 || (_city$children = city.children) === null || _city$children === void 0 ? void 0 : _city$children.find(item => item.label === val.area);
          selectedOptions = province !== null && province !== void 0 && province.value ? [province === null || province === void 0 ? void 0 : province.value, city === null || city === void 0 ? void 0 : city.value, area === null || area === void 0 ? void 0 : area.value] : [];
        } catch (error) {}
        form.value = {
          ...JSON.parse(JSON.stringify(val)),
          menu: val.menu.split(';'),
          password: '',
          selectedOptions
        };
      } else {
        resetForm();
      }
    });
    const ruleFormRef = ref(null);
    const activeNames = ref(['1']);
    const searchType = ref('');
    const list = ref([]);
    const currentValue = ref('');
    const dataLoading = ref(false);
    const isSearch = ref(false);
    const handleSearch = (type, value) => {
      searchType.value = type;
      currentValue.value = value;
      console.log(value);
      isSearch.value = true;
    };
    const handleChangeValue = value => {
      if (searchType.value === 'sms') {
        form.value.smsId = value;
      } else if (searchType.value === 'fs') {
        form.value.fsTenantId = value;
      } else if (searchType.value === 'account') {
        form.value.accountId = value;
      }
    };
    const handleChangeKeyword = async keyword => {
      let res = [];
      dataLoading.value = true;
      if (searchType.value === 'sms') {
        const smsRes = await getSmsUserConfigPage({
          pageSize: 200,
          tenantId: props.parentId
        });
        res = smsRes.records;
      } else if (searchType.value === 'account') {
        const smsRes = await getAllAccountData({
          pageSize: 200,
          status: 1000
        });
        res = smsRes.records;
      } else if (searchType.value === 'fs') {
        const smsRes = await getFeishuTenantList({
          pageSize: 200
        });
        res = smsRes.records;
      }
      if (keyword) {
        list.value = res.filter(item => {
          var _item$appName;
          return item.name.includes(keyword) || ((_item$appName = item.appName) === null || _item$appName === void 0 ? void 0 : _item$appName.includes(keyword));
        }).map(item => {
          console.log(item, 'item', item.fsTenantId, 'item.fsTenantId');
          return {
            value: item.tenantKey || item.id,
            label: item.name || item.appName
          };
        });
      } else {
        console.log(res, 'res');
        list.value = res.map(item => ({
          value: item.tenantKey || item.id,
          label: item.name || item.appName
        }));
      }
      dataLoading.value = false;
    };
    const submitHandler = async () => {
      if (!form.value) return;
      try {
        await ruleFormRef.value.validate();

        // password字段为空 && 删除password字段
        !form.value.password && delete form.value.password;
        await addEnterprise({
          ...form.value,
          expireDate: dayjs(form.value.expireDate).format('YYYY-MM-DD HH:mm:ss'),
          menu: form.value.menu.join(';'),
          tenantId: props.parentId
        });
        emits('data');
        ElMessage({
          message: '修改成功',
          type: 'success'
        });
        dialogTenantVisible.value = false;
        // fsOptions.value = []
        resetForm();
        emits('clearModel');
      } catch (error) {
        var _props$model;
        ElMessage({
          message: `${(_props$model = props.model) !== null && _props$model !== void 0 && _props$model.id ? '修改' : '新增'}失败,校验未成功`,
          type: 'warning'
        });
      }
    };
    const resetForm = () => {
      var _ruleFormRef$value;
      (_ruleFormRef$value = ruleFormRef.value) === null || _ruleFormRef$value === void 0 || _ruleFormRef$value.resetFields();
      form.value = {
        picture: '',
        picUrl: '',
        username: '',
        fsTenantId: '',
        password: '',
        name: '',
        expireDate: Date.now(),
        // clinicId: '',
        menu: [],
        accountId: '',
        description: '',
        mobile: '',
        address: '',
        telephone: '',
        email: '',
        isParent: 0,
        // 是否是总部
        parentId: '',
        smsId: '',
        enableStatus: 1,
        contact: '',
        isSwitchMall: 0,
        // 是否开通商城功能
        qrCodePath: '' // his扫描二维码跳转到预约小程序界面路径
      };
    };
    return (_ctx, _cache) => {
      const _component_CropImageUpload = _resolveComponent("CropImageUpload");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_checkbox_button = _resolveComponent("el-checkbox-button");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: _unref(dialogTenantVisible),
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _isRef(dialogTenantVisible) ? dialogTenantVisible.value = $event : null),
        title: __props.type === 'password' ? '密码修改' : (__props.type === 'add' ? '新增' : '修改') + '诊所',
        "destroy-on-close": "",
        width: "60%",
        class: "dialog-class",
        onClosed: _cache[27] || (_cache[27] = $event => _ctx.$emit('clearModel')),
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[25] || (_cache[25] = $event => dialogTenantVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 确认 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "150px",
          rules: _unref(formRule),
          "status-icon": "",
          model: form.value,
          ref_key: "ruleFormRef",
          ref: ruleFormRef
        }, {
          default: _withCtx(() => [__props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "头像",
            prop: "picture"
          }, {
            default: _withCtx(() => {
              var _props$model2;
              return [_createVNode(_component_CropImageUpload, {
                modelValue: form.value.picture,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.picture = $event),
                id: (_props$model2 = __props.model) === null || _props$model2 === void 0 ? void 0 : _props$model2.id
              }, null, 8, ["modelValue", "id"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "logo",
            prop: "picture"
          }, {
            default: _withCtx(() => {
              var _props$model3;
              return [_createVNode(_component_CropImageUpload, {
                modelValue: form.value.picUrl,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.picUrl = $event),
                id: (_props$model3 = __props.model) === null || _props$model3 === void 0 ? void 0 : _props$model3.id,
                width: 462,
                height: 110
              }, null, 8, ["modelValue", "id"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "appLink账号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.username,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.username = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type === 'add' || __props.type === 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 3,
            label: "appLink密码"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.password = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 4,
            label: "医院/诊所名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.name = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 5,
            label: "是否总部",
            style: {
              "display": "flex",
              "align-items": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              "active-value": 1,
              "inactive-value": 0,
              "active-text": "总部",
              "inactive-text": "非总部",
              modelValue: form.value.isParent,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.isParent = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' && form.value.isParent === 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 6,
            label: "归属总部",
            style: {
              "display": "flex",
              "align-items": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.parentId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.parentId = $event),
              class: "m-2",
              placeholder: "请选择归属的总部"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headquartersFromOptions, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 7,
            label: "新版二维码",
            style: {
              "display": "flex",
              "align-items": "center"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              "active-value": 2,
              "inactive-value": 1,
              "active-text": "启用",
              "inactive-text": "不启用",
              modelValue: form.value.enableStatus,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.enableStatus = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 8,
            label: "服务过期时间",
            prop: "expireDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              "unlink-panels": "",
              modelValue: form.value.expireDate,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.expireDate = $event),
              type: "date",
              placeholder: "请选择过期时间",
              shortcuts: _unref(shortcuts),
              size: "default"
            }, null, 8, ["modelValue", "shortcuts"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 9,
            label: "诊所描述信息",
            prop: "description"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: form.value.description,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.description = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 10,
            label: "医生端菜单配置"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
              modelValue: form.value.menu,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.menu = $event)
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(DOC_MENU), item => {
                return _openBlock(), _createBlock(_component_el_checkbox_button, {
                  key: item.value,
                  label: item.value
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
                  _: 2
                }, 1032, ["label"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_divider, {
            key: 11
          }, {
            default: _withCtx(() => [_createTextVNode(" 关联账号 ")]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 12,
            label: "飞书账号",
            prop: "fsTenantId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.fsTenantId,
              clickable: "",
              style: {
                "cursor": "pointer !important",
                "background-color": "#fff"
              },
              onClick: _cache[11] || (_cache[11] = $event => handleSearch('fs', form.value.fsTenantId || ''))
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 13,
            label: "公众号",
            prop: "accountId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.accountId,
              clickable: "",
              style: {
                "cursor": "pointer !important",
                "background-color": "#fff"
              },
              onClick: _cache[12] || (_cache[12] = $event => handleSearch('account', form.value.accountId || ''))
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 14,
            label: "短信账号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.smsId,
              clickable: "",
              style: {
                "cursor": "pointer !important",
                "background-color": "#fff"
              },
              onClick: _cache[13] || (_cache[13] = $event => handleSearch('sms', form.value.smsId || ''))
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 15,
            label: "是否开通商城功能"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              "active-value": 1,
              "inactive-value": 0,
              "active-text": "开通",
              "inactive-text": "不开通",
              modelValue: form.value.isSwitchMall,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.isSwitchMall = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 16,
            label: "是否启用新会员积分系统"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              "active-value": 1,
              "inactive-value": 0,
              "active-text": "启用",
              "inactive-text": "不启用",
              modelValue: form.value.membershipSystem,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.membershipSystem = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 17,
            label: "企微线索池显示"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              "active-value": 1,
              "inactive-value": 0,
              "active-text": "显示",
              "inactive-text": "不显示",
              modelValue: form.value.cluePoolShow,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.value.cluePoolShow = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 18,
            label: "his扫描路径"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.qrCodePath,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.value.qrCodePath = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_collapse, {
            key: 19,
            modelValue: activeNames.value,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => activeNames.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_collapse_item, {
              title: "诊所其他信息",
              name: "1"
            }, {
              default: _withCtx(() => [__props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                rules: [{
                  required: true,
                  message: '请选择省市区'
                }],
                label: "省市区",
                prop: "selectedOptions"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_cascader, {
                  placeholder: "请选择地区",
                  size: "default",
                  options: _unref(regionData),
                  modelValue: form.value.selectedOptions,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.value.selectedOptions = $event),
                  onChange: handleChangeCity
                }, null, 8, ["options", "modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                rules: [{
                  required: true,
                  message: '请选择省市区'
                }],
                label: "详细地址",
                prop: "address"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.address,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => form.value.address = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                rules: [{
                  required: true,
                  message: '请填入联系人'
                }],
                label: "联系人",
                prop: "contact"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.contact,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => form.value.contact = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                rules: [{
                  required: true,
                  message: '请选择省市区'
                }],
                label: "手机号码",
                prop: "mobile"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.mobile,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => form.value.mobile = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                label: "座机号码",
                prop: "telephone"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.telephone,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => form.value.telephone = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true), __props.type !== 'password' ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 5,
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.email,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => form.value.email = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["rules", "model"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_unref(AccountSearch), {
        modelValue: isSearch.value,
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => isSearch.value = $event),
        type: searchType.value,
        onChangeKeyword: handleChangeKeyword,
        list: list.value,
        value: currentValue.value,
        onChangeValue: handleChangeValue,
        loading: dataLoading.value
      }, null, 8, ["modelValue", "type", "list", "value", "loading"])]);
    };
  }
};